import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { toast } from "sonner";
import { Bell, Check, Trash2, CheckCheck } from "lucide-react";

export default function Notifications() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({ queryKey: ["notifications"], queryFn: async () => (await api.get("/notifications")).data.data });
  const refresh = () => qc.invalidateQueries({ queryKey: ["notifications"] });

  const markRead = async (id) => { await api.patch(`/notifications/${id}/read`); refresh(); };
  const remove = async (id) => { await api.delete(`/notifications/${id}`); refresh(); };
  const markAll = async () => { await api.post("/notifications/read-all"); toast.success("Tutte segnate come lette"); refresh(); };

  return (
    <div>
      <PageHeader title="Notifiche" subtitle="Aggiornamenti e avvisi del tuo account" icon={Bell}
        actions={<Button variant="outline" className="rounded-lg" onClick={markAll} data-testid="mark-all-notifications"><CheckCheck className="mr-1 h-4 w-4" /> Segna tutte lette</Button>} />
      <div className="space-y-2" data-testid="notifications-list">
        {isLoading ? Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="h-20 rounded-xl" />) : (
          data?.notifications.length === 0 ? (
            <Card className="border-dashed"><CardContent className="flex flex-col items-center gap-2 py-12 text-center"><Bell className="h-10 w-10 text-muted-foreground" /><p className="text-sm text-muted-foreground">Nessuna notifica</p></CardContent></Card>
          ) : data?.notifications.map((n) => (
            <Card key={n.id} className={!n.read ? "border-primary/30 bg-primary/5" : ""} data-testid={`notif-${n.id}`}>
              <CardContent className="flex items-center gap-4 p-4">
                <div className={`flex h-10 w-10 items-center justify-center rounded-full ${!n.read ? "bg-primary/15 text-primary" : "bg-muted text-muted-foreground"}`}><Bell className="h-5 w-5" /></div>
                <div className="flex-1 cursor-pointer" onClick={() => n.link && navigate(n.link)}>
                  <p className="text-sm font-medium">{n.title}</p>
                  <p className="text-xs text-muted-foreground">{n.body}</p>
                  <p className="mt-0.5 text-[11px] text-muted-foreground">{new Date(n.created_at).toLocaleString("it-IT")}</p>
                </div>
                <div className="flex gap-1">
                  {!n.read && <Button variant="ghost" size="icon" onClick={() => markRead(n.id)} title="Segna letta"><Check className="h-4 w-4" /></Button>}
                  <Button variant="ghost" size="icon" onClick={() => remove(n.id)} title="Elimina"><Trash2 className="h-4 w-4" /></Button>
                </div>
              </CardContent>
            </Card>
          ))
        )}
      </div>
    </div>
  );
}
